import React from 'react';

const ChartContext = React.createContext({
  charts: [],
  dateFilter: 'today',
  setDateFilter: null,
  subFilter: null,
  setSubFilter: null,
  subIdFilter: null,
  setSubIdFilter: null,
});

export default ChartContext;
